export default __webpack_public_path__ + "static/menstruacion-end-game-mb-f36ec3fa8d2715e6cbd6a0b0ebe0d903.png";